import type { MisconceptionDefinition } from './types'

import { TIJD_KLOK_MISCONCEPTIONS } from './tijd/klok'
import { TIJD_DUUR_MISCONCEPTIONS } from './tijd/duur'
import { TIJD_OMREKENEN_MISCONCEPTIONS } from './tijd/omrekenen'
import { TIJD_KALENDER_MISCONCEPTIONS } from './tijd/kalender'
import { TIJD_SNELHEID_MISCONCEPTIONS } from './tijd/snelheid'

/**
 * TIJD — Tijd misconcepties (barrel).
 *
 * STATUS (juni 2026): **Barrel-split** — vergelijkbaar met TAA.
 *
 * Deze barrel concateneert vijf sub-registries onder `./tijd/`:
 * - `klok`       — digitale/analoge klok lezen, 12/24-uurs notatie,
 *                  conversie tussen notaties (TIJD-DIGITAAL, TIJD-ANALOOG,
 *                  TIJD-ANALOOG-GEDETAILLEERD, TIJD-12-24, TIJD-CONVERSIE)
 * - `duur`       — tijdsverschillen, schema/planning, afstand-tijd diagrammen
 *                  (TIJD-DUUR, TIJD-SCHEMA, TIJD-PLANNING, TIJD-DIAGRAM)
 * - `omrekenen`  — eenheid-conversies uur ↔ min ↔ sec ↔ decimaal en
 *                  gemengde notaties (TIJD-OMREKENEN, TIJD-SAMENGESTELD)
 * - `kalender`   — datumrekenen, dag-van-de-week, maand/jaargrenzen
 *                  (TIJD-KALENDER)
 * - `snelheid`   — AST-driehoek, gemiddelde snelheid, tijdzones
 *                  (TIJD-SNELHEID, TIJD-AFSTAND, TIJD-GEMIDDELDE,
 *                   TIJD-TIJDZONES)
 *
 * Achtergrond: de oorspronkelijke `tijd.ts` (748 regels, ~88 entries)
 * bundelde vijf cognitief verschillende sub-domeinen in één bestand.
 * De splitsing volgt het TAA-patroon en maakt diff/review per
 * sub-domein hanteerbaar.
 *
 * Upgrades juni 2026:
 * - TIJD-ANALOOG-GEDETAILLEERD krijgt eigen misconcepties
 *   (wijzers-verwisseld, 5-min-naar-1-min, kleine-streep-genegeerd) —
 *   de analoge-klok family had eerder geen specifieke entries.
 * - TIJD-SAMENGESTELD toegevoegd aan typicalFamilies van
 *   gemengd-cijfers-plakken / gemengd-1-uur-vergeten / gemengd-keer-100 /
 *   ignores-partial-hour — seeds verwijzen er al naar.
 *
 * Alle bestaande IDs zijn 1:1 behouden — seeds verwijzen ernaar via
 * `misconceptionTags`. Geen renames.
 *
 * Publieke API ongewijzigd: `index.ts` importeert `TIJD_MISCONCEPTIONS`
 * uit `./tijd`.
 */
export const TIJD_MISCONCEPTIONS: MisconceptionDefinition[] = [
  ...TIJD_KLOK_MISCONCEPTIONS,
  ...TIJD_DUUR_MISCONCEPTIONS,
  ...TIJD_OMREKENEN_MISCONCEPTIONS,
  ...TIJD_KALENDER_MISCONCEPTIONS,
  ...TIJD_SNELHEID_MISCONCEPTIONS,
]
